// Types
import { VesselRatingSummary } from '@molecules/index';
import { VesselDetail } from '@schemas/services';
import { RatingKeys, DateRangeType } from '@globalTypes/index';

/**
 * Extracts the current rating data for the given rating key and data type.
 *
 * @function
 * @param {VesselDetail[]} vesselDetail - The array of VesselDetail objects.
 * @param {RatingKeys} rating - The rating key.
 * @param {DateRangeType} typeData - The type of data ('ytd' or 'eoy') regarding.
 * @returns {VesselRatingSummary[]} The array of parsed rating data.
 */
export const vesselDetailToVesselRatingSummary = (
  vesselDetail: VesselDetail[],
  rating: RatingKeys,
  typeData: DateRangeType
): VesselRatingSummary[] =>
  vesselDetail.map(({ typeId, type, ytdRating, eoyRating }) => {
    const quantity = typeData === DateRangeType.yearToDate ? ytdRating[rating] : eoyRating[rating];
    return { typeId, type, typeData, rating, quantity };
  });
